<template>
  <div>
    <ion-list-header v-if="vehicles.length > 0">
      <ion-label>{{ $t("bookings.selectVehicle") }}</ion-label>
    </ion-list-header>
    <div
      class="alert-non"
      v-if="vehicles.length === 0"
      text
      type="warning"
      icon="mdi-calendar-remove"
    >
      {{ $t("bookings.noVehicles") }}
    </div>
    <ion-list v-if="vehicles.length > 0">
      <ion-item v-for="vehicle of vehicles" :key="vehicle.id">
        <ion-label>
          <span
            class="color"
            :style="{ backgroundColor: vehicle.color }"
          ></span>
          {{ vehicle.license_plate }}<br /><small>{{ vehicle.model }}</small>
          <div>{{ vehicle.price }}</div>
        </ion-label>
        <ion-checkbox
          slot="start"
          v-model="vehicle.isChecked"
          @update:modelValue="setChecked($event, vehicle)"
        >
        </ion-checkbox>
      </ion-item>
    </ion-list>
  </div>
</template>

<script>
import axios from "axios";
import { defineComponent } from "vue";
import { IonList, IonItem, IonLabel, IonCheckbox } from "@ionic/vue";
let source;

export default defineComponent({
  components: {
    IonList,
    IonItem,
    IonLabel,
    IonCheckbox,
  },
  props: {
    modelValue: {
      required: false,
      type: Array,
    },
    dates: {
      required: false,
      type: Object,
    },
    guest: {
      required: false,
      type: Boolean,
    },
    step: {
      required: true,
      type: Number,
    },
    checkInLocationId: {
      required: false,
      type: Number,
    },
    checkOutLocationId: {
      required: false,
      type: Number,
    },
    vehicleTypeId: {
      required: false,
      type: Number,
    },
  },
  data() {
    return {
      vehicles: [],
      selectedVehicles: [],
    };
  },
  watch: {
    dates: {
      deep: true,
      handler(newDates) {
        if (newDates.start !== null) {
          this.getAvailableVehicles();
        }
      },
    },
    checkInLocationId: {
      deep: false,
      handler(newVal) {
        this.getAvailableVehicles();
      },
    },
    checkOutLocationId: {
      deep: false,
      handler(newVal) {
        this.getAvailableVehicles();
      },
    },
    selectedVehicles(newVal) {
      this.$emit("update:modelValue", newVal);
      if (this.selectedVehicles.length > 0) {
        this.$emit("valid", 5, true);
      } else {
        this.$emit("valid", 5, false);
      }
    },
    step(curretStep, prevStep) {
      if (curretStep === 5) {
        if (this.guest && prevStep === 4 && this.vehicles.length > 0) {
          this.setChecked(true, this.vehicles[0]);
          this.$emit("continue");
        }
        if (this.guest && prevStep === 6 && this.vehicles.length > 0) {
          this.$emit("back");
        }
      }
    },
  },
  methods: {
    getAvailableVehicles() {
      if (this.dates.start === null || this.dates.end === null || this.checkInLocationId === null || this.checkOutLocationId === null || this.vehicleTypeId === null) return;
      
      // Check if a CancelToken.source has been assigned to the source variable, then call the cancel method when true.
      if (source) source.cancel('Operation canceled by the user.');
      
      // Assign the source factory to the source variable
      source = axios.CancelToken.source();
      
      const option = {
        cancelToken: source.token // add the cancel token, as an option for the request
      };

      axios.post("/bookings/availability", {
        dates: this.dates,
        checkInLocationId: this.checkInLocationId,
        checkOutLocationId: this.checkOutLocationId,
        vehicleTypeId: this.vehicleTypeId,
      }, option).then((resp) => {
        this.selectedVehicles = [];
        this.vehicles = resp.data;
        if (!this.guest) {
          this.setChecked(true, this.vehicles[0]);
        }
      });
    },
    setChecked($event, vehicle) {
      vehicle.isChecked = $event;
      this.selectedVehicles = this.vehicles.filter((vehicle) => {
        return vehicle.isChecked;
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.v-list-item__action {
  margin-right: 16px;
}
.v-avatar {
  margin: 0 14px 0 -16px;
}
.alert-non {
  background: #f7f7cf;
  color: #7a630e;
  font-weight: 500;
  padding: 20px;
  margin: 30px 16px;
  width: 95%;
  z-index: 1;
}
.color {
  width: 18px;
  height: 18px;
  display: inline-block;
  position: relative;
  top: 10px;
  margin-right: 5px;
  float: right;
  border-radius: 10px;
}
</style>
